<template>
  <VeeForm class="login-form" @submit="onLogin">
    <h2>{{ $filters.whitespacedPunctuation($t("ETAB.PAGES.LOGIN.@WELCOME")) }}</h2>

    <fieldset>
      <!-- email -->
      <Field
        :ref="IAuth.login"
        v-slot="{ errors, field, value }"
        v-model.trim="authData[IAuth.login]"
        :name="$filters.formLabelValidation($t('ETAB.FORMS.LABELS.@EMAIL'))"
        :rules="{ required: true, email: true }"
      >
        <QInput
          v-bind="field"
          :model-value="value"
          class="login-form-field q-input-borderless"
          :label="$t('ETAB.FORMS.LABELS.@EMAIL')"
          tabindex="1"
          filled
          dark
          clearable
          color="white"
          :name="IAuth.login"
          type="email"
          :error="errors.length > 0"
        />
      </Field>

      <!-- password -->
      <Field
        v-slot="{ errors, field, value }"
        v-model.trim="authData[IAuth.password]"
        :name="$filters.formLabelValidation($t('ETAB.FORMS.LABELS.@PASSWORD'))"
        :rules="{ required: true }"
      >
        <QInput
          v-bind="field"
          :model-value="value"
          class="login-form-field q-input-borderless"
          :label="$t('ETAB.FORMS.LABELS.@PASSWORD')"
          tabindex="1"
          filled
          dark
          color="white"
          :name="IAuth.password"
          :type="isPwd ? 'password' : 'text'"
          :error="errors.length > 0"
        >
          <template #append>
            <QIcon :name="isPwd ? 'icon-f-eye' : 'icon-f-eye-off'" class="cursor-pointer" @click="isPwd = !isPwd" />
          </template>
        </QInput>
      </Field>

      <div class="btn-forget">
        <QBtn flat :label="$t('ETAB.PAGES.LOGIN.@FORGOT_PASSWORD')" no-caps dense @click.prevent="onPasswordForget" />
        <br />
        <QBtn flat :label="$t('ETAB.PAGES.LOGIN.@FORGOT_EMAIL')" no-caps dense @click.prevent="onEmailForget" />
      </div>
    </fieldset>

    <fieldset class="login-form-actions">
      <QBtn type="submit" color="secondary" class="full-width btn-navigation" no-caps :label="$t('ETAB.BUTTONS.@CONNECT')" />
      <QBtn :label="$t('ETAB.BUTTONS.@INSCRIPTION')" color="white" class="full-width btn-navigation" no-caps flat @click="goToSignup" />
    </fieldset>
  </VeeForm>
</template>

<script>
  import { Form as VeeForm, Field } from "vee-validate";
  import { IAuth, AuthModel } from "@core/models";
  import { NotificationsManager } from "@core/managers/notifications.manager";
  import { MetaHelpers } from "@core/helpers";
  import { TrackingManager } from "@core/managers/tracking.manager";

  export default {
    components: {
      VeeForm,
      Field,
    },
    props: {
      prefilledEmail: { type: String, default: null },
    },
    emits: ["onLogin", "goToSignup", "onPasswordForget", "onEmailForget"],
    meta() {
      return MetaHelpers.setAutoMeta({
        title: this.$t("ETAB.PAGES.LOGIN.META.@TITLE"),
        description: this.$t("ETAB.PAGES.LOGIN.META.@DESCRIPTION"),
        canonical: `${window.location.origin}${window.location.pathname}${window.location.hash.split("?")[0]}`,
      });
    },
    data() {
      return {
        authData: new AuthModel(),
        isPwd: true,
      };
    },
    created() {
      this.IAuth = IAuth;
      this.prefillLoginIfAny();
    },
    methods: {
      prefillLoginIfAny() {
        if (this.prefilledEmail) {
          this.authData[IAuth.login] = this.prefilledEmail;
        }
      },
      async onLogin() {
        const login = this.authData.getLogin();
        const password = this.authData.getPassword();
        this.$emit("onLogin", { login, password });
      },
      goToSignup() {
        TrackingManager.addEvent({
          event: "login_goto_signup",
        });
        const login = this.authData.getLogin();
        this.$emit("goToSignup", { prefilledEmail: login });
      },
      async onPasswordForget() {
        TrackingManager.addEvent({
          event: "login_forgot_password",
        });
        // verify if email field is valid
        const loginValidation = await this.$refs[IAuth.login].validate();
        if (loginValidation.valid) {
          this.$emit("onPasswordForget", this.authData[IAuth.login]);
        } else {
          NotificationsManager.info({ message: "INFO.@FORGOT_PASSWORD_NEED_EMAIL" });
        }
      },
      async onEmailForget() {
        TrackingManager.addEvent({
          event: "login_forgot_email",
        });
        this.$emit("onEmailForget");
      },
    },
  };
</script>

<style lang="scss">
  .login-form {
    h2 {
      text-align: center;
      margin: 0 0 12px;
      font-size: 1.5rem;
    }

    .btn-forget {
      text-align: right;
      text-decoration: underline;
    }

    .login-form-field {
      padding-bottom: 10px;
    }

    fieldset:first-of-type {
      display: flex;
      flex-grow: 1;
      flex-direction: column;
    }

    .login-form-actions {
      margin-top: 10px;
      button:first-of-type {
        margin-bottom: 10px;
      }
    }
  }
</style>
